import { Button } from '@material-ui/core';
import React from 'react';
import { Control, useForm, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import {
  AppDatePicker,
  AppSelect,
  AppTextField,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { Translations } from '../../configuration';
import _ from 'lodash';
import { useHistory } from 'react-router';
import NavigationConfig from '../../../../navigation/config';
import { MessageIncomingStatus } from '../../configuration';
import * as MessageIncomingSelectors from 'redux/reducers/message_incoming_reducer/selectors';
import { readableMessageTypes } from 'config';
import SearchIcon from '@material-ui/icons/Search';
import useStyles from './styles';
import * as DateUtils from 'utils/dates';

interface FormFields {
  messageId: string | null;
  originatingCountry: string | null;
  messageType: string | null;
  status: string | null;
  date_from: Date | null;
  date_to: Date | null;
}

interface IProps {
  messageId: string | null;
  originatingCountry: string | null;
  messageType: string | null;
  status: string | null;
  date_from: Date | null;
  date_to: Date | null;
}

const FilterForm = (props: IProps) => {
  const history = useHistory();
  const classes = useStyles();

  const defaultValues = {
    messageId: props.messageId ? props.messageId : null,
    originatingCountry: props.originatingCountry
      ? props.originatingCountry
      : null,
    messageType: props.messageType ? props.messageType : null,
    status: props.status ? props.status : null,
    date_from: props.date_from ? props.date_from : null,
    date_to: props.date_to ? props.date_to : null,
  };
  const { control, errors, handleSubmit } = useForm<FormFields>({
    defaultValues: defaultValues,
  });

  const onSubmit = (data: any) => {
    let query = [];
    if (data.messageId) {
      query.push({
        key: 'messageId',
        value: data.messageId,
      });
    }
    if (data.originatingCountry) {
      query.push({
        key: 'originatingCountry',
        value: data.originatingCountry,
      });
    }
    if (data.messageType) {
      query.push({
        key: 'messageType',
        value: data.messageType,
      });
    }
    if (data.status) {
      query.push({
        key: 'status',
        value: data.status,
      });
    }
    if (data.date_from) {
      const date_from = DateUtils.DateInQueryFormat(data.date_from);
      query.push({
        key: 'date_from',
        value: date_from,
      });
    }
    if (data.date_to) {
      const date_to = DateUtils.DateInQueryFormat(data.date_to);
      query.push({
        key: 'date_to',
        value: date_to,
      });
    }
    let queryString = '';
    query.map((query, index) => {
      if (index == 0) queryString += `?${query.key}=${query.value}`;
      else queryString += `&${query.key}=${query.value}`;
    });
    history.push(NavigationConfig.messageIncomingPage().path + queryString);
  };

  const clearFilter = () => {
    history.push(NavigationConfig.messageIncomingPage().path);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '0.6rem' }}>
      <GridLayout
        elements={[
          {
            element: (
              <div
                className={classes.filter_header}
                style={{ marginTop: '0.5rem' }}
              >
                <SearchIcon style={{ marginRight: '1rem' }} />
                <span style={{ fontSize: '1.2rem' }}>
                  <TranslatedText textMap={Translations.search} />
                </span>
              </div>
            ),
            size: 2,
            id: 'space',
          },
          {
            element: <span></span>,
            size: 8,
            id: 'space',
          },
          {
            element: (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{
                    width: '47%',
                    marginTop: '0.3rem',
                    marginRight: '0.25rem',
                  }}
                >
                  <TranslatedText textMap={Translations.search} />
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    width: '47%',
                    marginTop: '0.3rem',
                    marginLeft: '0.25rem',
                  }}
                  onClick={clearFilter}
                >
                  <TranslatedText textMap={Translations.clear} />
                </Button>
              </div>
            ),
            size: 2,
            id: 'action',
          },
          {
            element: renderMessageIdField(errors, control),
            size: 2,
            id: 'messageId',
          },
          {
            element: renderOriginatingCountryField(errors, control),
            size: 2,
            id: 'originatingCountry',
          },
          {
            element: renderMessageTypeField(errors, control),
            size: 2,
            id: 'messageType',
          },
          {
            element: renderStatusField(errors, control),
            size: 2,
            id: 'status',
          },
          {
            element: renderDateStartField(errors, control),
            size: 2,
            id: 'date_from',
          },
          {
            element: renderDateEndField(errors, control),
            size: 2,
            id: 'date_to',
          },
          // {
          //   element: <React.Fragment />,
          //   size: 10,
          //   id: 'space',
          // },
        ]}
      />
    </form>
  );
};

const renderMessageIdField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      fullWidth
      id="messageId"
      label={<TranslatedText textMap={Translations.messageId} />}
      error={'messageId' in errors}
      name="messageId"
      control={control}
      rules={{}}
      helperText={errors.messageId && errors.messageId.message}
    />
  );
};

const renderOriginatingCountryField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  let countries =
    MessageIncomingSelectors.useGetMemberStateExcludeCyprusCountries();
  let select_countries = [];
  select_countries.push({
    id: '',
    label: 'Originating Country',
  });
  if (countries && countries.length > 0) {
    for (let country of countries)
      select_countries.push({
        id: country.code,
        label: `${country.code} - ${country.description}`,
      });
    select_countries.push({
      id: 'VM',
      label: `VM - CESOP`,
    });
  }
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.originatingCountry} />}
      id="originatingCountry"
      name="originatingCountry"
      error={'originatingCountry' in errors}
      control={control}
      rules={{}}
      options={select_countries as any}
      helperText={
        errors.originatingCountry && errors.originatingCountry.message
      }
    />
  );
};

const renderMessageTypeField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const messageTypes = [
    'OSSVRE-MSG.MOSS',
    'OSSVRE-MSG.VOES',
    'OSSVRE-MSG.IMP',
    'OSSVRI-MSG.MOSS',
    'OSSVRI-MSG.VOES',
    'OSSVRI-MSG.IMP',
    'OSSVRMSCON-MSG.MOSS',
    'OSSVRMSCON-MSG.VOES',
    'OSSVRMSCON-MSG.IMP',
    'OSSVRQ-MSG.MOSS',
    'OSSVRQ-MSG.VOES',
    'OSSVRQ-MSG.IMP',
    'PMT-MSG.MOSS',
    'PMT-MSG.VOES',
    'PMT-MSG.IMP',
    'PRI-MSG.MOSS',
    'PRI-MSG.VOES',
    'PRI-MSG.IMP',
    'REG-MSG.MOSS',
    'REG-MSG.VOES',
    'REG-MSG.IMP',
    'RFI-MSG.MOSS',
    'RFI-MSG.VOES',
    'RFI-MSG.IMP',
    'RQE-MSG.MOSS',
    'RQE-MSG.VOES',
    'RQE-MSG.IMP',
    'RQI-MSG.MOSS',
    'RQI-MSG.VOES',
    'RQI-MSG.IMP',
    'TEM-MSG.MOSS',
    'TEM-MSG.VOES',
    'TEM-MSG.IMP',
    'VRR-MSG.MOSS',
    'VRR-MSG.VOES',
    'VRR-MSG.IMP',
    'VRMSCON-MSG.MOSS',
    'VRMSCON-MSG.VOES',
    'VRMSEST-MSG.MOSS',
    'OSSVRMSEST-MSG.MOSS',
    'VRQ-MSG.MOSS',
    'VRQ-MSG.VOES',
    'VRI-MSG.MOSS',
    'VRI-MSG.VOES',
    'VRE-MSG.MOSS',
    'VRE-MSG.VOES',
    'RIB-MSG.MOSS',
    'RIB-MSG.VOES',
    'RIB-MSG.IMP',
    'PRC-MSG.MOSS',
    'PRC-MSG.VOES',
    'PRC-MSG.IMP',
  ];
  let select_options = [];
  select_options.push({
    id: '',
    label: Translations.messageType.English,
  });
  select_options.push(
    ...messageTypes
      .map((messageType) => ({
        id: messageType,
        label: _.get(readableMessageTypes, messageType) || messageType,
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  );
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.messageType} />}
      id="messageType"
      name="messageType"
      error={'messageType' in errors}
      control={control}
      rules={{}}
      options={select_options as any}
      helperText={errors.messageType && errors.messageType.message}
    />
  );
};

const renderStatusField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  var select_options: any[] = [];
  select_options.push({
    id: null,
    label: 'Status',
  });
  for (let status of MessageIncomingStatus)
    select_options.push({
      id: status.id,
      label: status.label,
    });
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText defaultText={'Status'} />}
      id="status"
      name="status"
      error={'status' in errors}
      control={control}
      rules={{}}
      options={select_options}
      helperText={errors.status && errors.status.message}
    />
  );
};

const renderDateStartField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppDatePicker
      fullWidth
      autoOk
      label={<TranslatedText defaultText={'From'} />}
      error={'date_from' in errors}
      control={control}
      rules={{}}
      name="date_from"
      helperText={errors.date_from && errors.date_from.message}
    />
  );
};

const renderDateEndField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppDatePicker
      fullWidth
      autoOk
      label={<TranslatedText defaultText={'To'} />}
      error={'date_to' in errors}
      control={control}
      rules={{}}
      name="date_to"
      helperText={errors.date_to && errors.date_to.message}
    />
  );
};

export default FilterForm;
